import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';



const styles = theme => ({
   leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  root: {
    width: '100%',    
    textAlign:"center"
    
  },
  tableContainer:
  {
    display:"inline-block",
    width: '100%',
    //maxWidth: '80%',
  },
  paper: {
    display:"inline-block",
    width: '100%',
    //maxWidth: '80%',
    marginTop: theme.spacing.unit * 3,
    overflow: 'visible'
  },
  table: {
    minWidth: 700,
    overflow: "visible"
  },
  tableHead:
  {
    backgroundColor: "#aaa",
    height: "56px",
color: "rgba(0, 0, 0, 0.54)",
fontSize: "0.75rem",
fontWeight: 500,
fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'

  },
   
  tableRow:
  {
    overflow: "visible"
  },
   button: {
    margin: theme.spacing.unit,
  },
  tableCellAssign:
  {
    overflow: "visible",
  },
  tableCellAssignDiv:
  {
    overflow: "visible",
    height: "40px",
    width: "300px"
  },
  tableRowHover: {
     cursor: 'pointer',
    '&:hover': {
      backgroundColor: "#777",
    },
  },
   tableRowSelected: {
    backgroundColor: "#666"
  },
  buttonContainer:
  {
    width: '100%',
    maxWidth: '80%',
    height: '150px', //some spacing to click on to remove selection
    display:"inline-block",
  },
  buttonContainerLeft:
  {
    float: "left"
  },
  buttonContainerRight:
  {
    float: "right"
  },
});


class SimpleRawTableRow extends Component {
  
  render() {

    let {row, idx,classes} = this.props;

    return <tr key={idx} className = {row.selectable ? classNames(classes.tableRow, classes.tableRowHover,this.state.selectedRow === idx && classes.tableRowSelected): classes.tableRow} onClick={(event) => {if (row.selectable) {event.stopPropagation(); this.setState({selectedRow : idx})}}}>{row.columns.map((c, i) => <td key={i} style={row.styles && row.styles[i]}>{c}</td>)}</tr>;
  }
};

let StyledSimpleRawTableRow = (withStyles(styles)(SimpleRawTableRow));

export class SimpleRawTable extends Component {
  static propTypes = {
    titleRow: PropTypes.array.isRequired,
    rows: PropTypes.array.isRequired,
    maxWidth: PropTypes.string
  };

  static defaultProps = {
    editText: "Edit",
    addText: "New",
    deleteText: "Delete",
    editable: true
  };

   state = {
    selectedRow: -1,
    editDialogOpen: false,
    editDialogNode: <div />
  };

  onCloseEditDialog()
  {
    this.setState({editDialogOpen: false, editDialogNode: {}});
  }

  isString(obj)
  {
    return (typeof obj === 'string' || obj instanceof String);
  }

  render() {

    

    const { classes, rows, titleRow } = this.props;

    return (
     <div className={classes.root}  onClick={(event) => {console.log(this.state.editDialogOpen);if (!this.state.editDialogOpen) { console.log("unselect");event.stopPropagation();this.setState({selectedRow:-1}); }}}>
    <div className={classes.tableContainer}>
    
    
      <table  className="table tableCompact">
        <thead  className={classes.tableHead}>
          <tr>
                                {titleRow.map((c, i) => <td key={i}>{c}</td>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((row,idx) => {
            return <StyledSimpleRawTableRow key={idx} row={row} idx={idx} />;
          })}
        </tbody>
      </table>
      
    
    
      </div>
      </div>
    )
  }
}


export default withStyles(styles)(SimpleRawTable);


// WEBPACK FOOTER //
// ./src/features/common/SimpleRawTable.js